const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "path",
  fill: "none",
  stroke: "#0acf97",
  strokeMiterlimit: 10,
  d: "M425.9,52.1L425.9,52.1c-2.2-2.6-6-2.6-8.3-0.1l-42.7,46.2l-14.3-16.4                                 c-2.3-2.7-6.2-2.7-8.6-0.1c-1.9,2.1-2,5.6-0.1,7.7l17.6,20.3c0.2,0.3,0.4,0.6,0.6,0.9c1.8,2,4.4,2.5,6.6,1.4c0.7-0.3,1.4-0.8,2-1.5                                 c0.3-0.3,0.5-0.6,0.7-0.9l46.3-50.1C427.7,57.5,427.7,54.2,425.9,52.1z"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "path",
  fill: "none",
  stroke: "#0acf97",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  cx: 80.6,
  cy: 80.6,
  r: 62.1
});
var _ref4 = /*#__PURE__*/React.createElement("polyline", {
  className: "path",
  fill: "none",
  stroke: "#0acf97",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  points: "113,52.8                                 74.1,108.4 48.2,86.4 "
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "spin",
  fill: "none",
  stroke: "#0acf97",
  strokeWidth: 4,
  strokeMiterlimit: 10,
  strokeDasharray: "12.2175,12.2175",
  cx: 80.6,
  cy: 80.6,
  r: 73.9
});
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 161.2 161.2",
    enableBackground: "new 0 0 161.2 161.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.c3043eb578505546e9b3f21dd0b5f155.svg";
export { ForwardRef as ReactComponent };